export default function (terms) {
    if (!terms || typeof terms !== 'string') {
        return 'counselor';
    }
    const preparedTerms = terms.toLowerCase().replace(/\s+/g, '');
    switch (preparedTerms) {
        case 'students&counselors':
            return 'counselor';
        case 'candidates&employers':
            return 'employer';
        default:
            return 'advisor';
    }
}



// WEBPACK FOOTER //
// ./src/client/utils/getAdvisorTitleByTerms.js